import { useMutation, useQueryClient } from '@tanstack/react-query';
import Api, { withAcl } from 'hooks/Api';
import { useProvider } from 'utils/providers/Provider';
import { useAdminParams } from 'utils/helpers';
import { DATA_SOURCE, DATA_TYPE } from 'utils/types';

import c from '../utils/constants';

export type CreateDataPayload = {
  name: string;
  description?: string;
  type: DATA_TYPE;
  source: DATA_SOURCE;
  meta: Meta;
};

interface Meta {
  options?: Option[];
  min?: number | null;
  max?: number | null;
  format?: string;
}

interface Option {
  label: string;
  value: string;
}

export default function useCreateData() {
  const queryClient = useQueryClient();
  const { state } = useProvider();
  const args = state;
  const { accountId, accountUserId } = useAdminParams();

  return useMutation({
    mutationFn: async (payload: CreateDataPayload) => {
      const api = new Api(args);

      const data = await api.post(
        await withAcl({
          account: {
            url: '/api/v3/data',
            payload,
          },
          admin: {
            url: `/api/v2/accounts/${accountId}/users/${accountUserId}/data`,
            payload,
          },
        }),
      );

      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [c.FIELDS] });
    },
  });
}
